// extracted by mini-css-extract-plugin
export default {"editProcessItemDialog":"editProcessItemDialog-ccHZS","info":"info-YPVLz","processItemViz":"processItemViz-w2Hku","errorMessage":"errorMessage-oYT4S"};